import React from 'react';
import { mdiChevronDown, mdiChevronRight } from '@mdi/js';
import Icon from '@mdi/react';
import { Box, IconButton } from '@mui/material';

/**
 * Custom button for expaning/collapsing the "Master Detail" area of a DataGrid row.
 */
export default ({ show, expanded }: IDocTableDetailToggleButtonProps) => {
    if (!show) {
        return <Box sx={{ width: 34, height: 34 }} />;
    }

    return (
        <IconButton size='small' aria-label={expanded ? 'Close' : 'Open'}>
            <Icon path={expanded ? mdiChevronDown : mdiChevronRight} size={1} />
        </IconButton>
    );
};

/**
 * Interface that describes the props for a DocTableDetailToggleButton component.
 */
export interface IDocTableDetailToggleButtonProps {
    /** Whether the button should be shown at all. */
    show: boolean;

    /** The expanded state of the row's Master Detail section. */
    expanded: boolean;
}
